"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearSmMallCache = clearSmMallCache;
exports.exportJdSkuList = exportJdSkuList;
exports.getJdCategoryList = getJdCategoryList;
exports.getJdCategoryOneList = getJdCategoryOneList;
exports.getJdCategoryThreeList = getJdCategoryThreeList;
exports.getJdCategoryTwoList = getJdCategoryTwoList;
exports.getJdGoodsDetail = getJdGoodsDetail;
exports.getJdMallSortOptions = getJdMallSortOptions;
exports.getJdSkuList = getJdSkuList;
exports.getSelfCategoryTree = getSelfCategoryTree;
exports.getSmGoodsPriceAdjustRecords = getSmGoodsPriceAdjustRecords;
exports.smGoodsPriceAdjust = smGoodsPriceAdjust;
exports.syncJdCategoryAll = syncJdCategoryAll;
exports.updateJdCategoryStatus = updateJdCategoryStatus;
exports.updateJdGoodsStatus = updateJdGoodsStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 商城SKU列表（Sam）
 */
function getJdSkuList(params) {
  return (0, _request.default)({
    url: '/admin/sm/mall/goods/list',
    method: 'POST',
    data: params || {}
  });
}

/**
 * 导出商品列表（Sam）
 */
function exportJdSkuList(params) {
  return (0, _request.default)({
    url: '/admin/sm/store/sku/export',
    method: 'GET',
    params: params
  });
}

/**
 * 商城分类列表（树形）（Sam）
 * POST sm/mall/category/list
 */
function getJdCategoryList(data) {
  return (0, _request.default)({
    url: '/admin/sm/mall/category/list',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 商城分类状态切换（Sam）
 * POST sm/mall/category/status
 */
function updateJdCategoryStatus(data) {
  return (0, _request.default)({
    url: '/admin/sm/mall/category/status',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 商城分类同步全部（Sam）
 * POST sm/mall/category/syncAll
 */
function syncJdCategoryAll() {
  return (0, _request.default)({
    url: '/admin/sm/mall/category/syncAll',
    method: 'POST'
  });
}

/**
 * 商城分类-一级下拉（Sam）
 * POST sm/mall/category/one/list
 * body: keyword
 */
function getJdCategoryOneList(data) {
  return (0, _request.default)({
    url: '/admin/sm/mall/category/one/list',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 商城分类-二级下拉（Sam）
 * POST sm/mall/category/two/list
 * body: keyword, categoryOneId
 */
function getJdCategoryTwoList(data) {
  return (0, _request.default)({
    url: '/admin/sm/mall/category/two/list',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 商城分类-三级下拉（Sam）
 * POST sm/mall/category/three/list
 * body: keyword, categoryTwoId
 */
function getJdCategoryThreeList(data) {
  return (0, _request.default)({
    url: '/admin/sm/mall/category/three/list',
    method: 'POST',
    data: data || {}
  });
}

/**
 * SKU列表-排序选项（Sam）
 * POST sm/mall/sort/options
 */
function getJdMallSortOptions() {
  return (0, _request.default)({
    url: '/admin/sm/mall/sort/options',
    method: 'POST'
  });
}

/**
 * 商品上下架（Sam）
 * POST sm/mall/goods/updateStatus
 * body: listStatus, skuId
 */
function updateJdGoodsStatus(data) {
  return (0, _request.default)({
    url: '/admin/sm/mall/goods/updateStatus',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 商品详情（Sam）
 * POST sm/mall/goods/detail，参数 skuId；返回即 data
 */
function getJdGoodsDetail(data) {
  return (0, _request.default)({
    url: '/admin/sm/mall/goods/detail',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 手动清除山姆前台缓存
 * POST /admin/sm/mall/cache/clear
 */
function clearSmMallCache() {
  return (0, _request.default)({
    url: '/admin/sm/mall/cache/clear',
    method: 'POST'
  });
}

/**
 * 自营分类树（公用，不区分 Sam/JD）
 * GET category/list/tree?status=-1&type=8
 */
function getSelfCategoryTree() {
  // return request({
  //   url: '/admin/category/list/tree?status=-1&type=8',
  //   method: 'GET',
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/product/category/list/tree?status=-1&type=8',
    method: 'GET'
  });
}

/**
 * 山姆单商品调价
 * POST /admin/sm/mall/goods/price-adjust
 * body: skuId, skuName, retail, sellPrice, categoryId, adjustType, adjustRatio, remark
 */
function smGoodsPriceAdjust(data) {
  return (0, _request.default)({
    url: '/admin/sm/mall/goods/price-adjust',
    method: 'POST',
    data: data
  });
}

/**
 * 山姆单商品调价记录列表（分页）
 * POST /admin/sm/mall/goods/price-adjust/records
 * body: skuId, page, limit
 */
function getSmGoodsPriceAdjustRecords(data) {
  return (0, _request.default)({
    url: '/admin/sm/mall/goods/price-adjust/records',
    method: 'POST',
    data: data
  });
}